module.exports = __webpack_public_path__ + "static/media/80sMusicThumb.bfcfbe7d.jpg";